export enum ErrorCodeEnum {
    FORBIDDEN = 'FORBIDDEN',
    NOT_FOUND = 'NOT_FOUND',
    OTHER = 'OTHER',
}
